import type { StatsigClient } from '@statsig/js-client'

import type { ParserOf } from './parser-of'

export interface ExperimentOptions<T> {
  experimentName: string
  parameterName: string
  defaultValue: T
  parser: ParserOf<T>
}

export function getExperimentValue<T>(statsigClient: StatsigClient, options: ExperimentOptions<T>): T {
  const { experimentName, parameterName, defaultValue, parser } = options

  try {
    const experiment = statsigClient.getExperiment(experimentName)
    const value = experiment.get(parameterName, defaultValue)
    return parser.parse(value)
  } catch {
    return defaultValue
  }
}
